import { render, staticRenderFns } from "./PagePermissions.vue?vue&type=template&id=45f1edcf&"
import script from "./PagePermissions.vue?vue&type=script&lang=js&"
export * from "./PagePermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports